export interface arrayOfObjects {
  array: any
  compareKey?: string
}

const uniqueObjects = (arr: arrayOfObjects['array'], compareKey = '_id') => {
  const uniqueIds = new Set()
  // eslint-disable-next-line
  // @ts-ignore
  const unique = arr.filter(element => {
    const isDuplicate = uniqueIds.has(element[compareKey])

    uniqueIds.add(element[compareKey])

    if (!isDuplicate) {
      return true
    }
  })

  return unique
}

export default uniqueObjects
